import React, { useEffect } from 'react'

import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import './PriorDaysConfigPage.css'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const PriorDaysConfigPageUI = ({
  context,
  reminderList = [],
  loading = false,
  error = null,
  isEditModalOpen = false,
  selectedReminder = null,
  updateSuccess = false,
  resetSuccess = () => { },
  onEditClick = () => { },
  onModalClose = () => { },
  onDayOfMonthChange = () => { },
  onUpdateReminder = () => { },
}) => {

  const daysOptionsForReminder = [
    { value: "None", label: 'None' },
    { value: 15, label: '15' },
    { value: 16, label: '16' },
    { value: 17, label: '17' },
    { value: 18, label: '18' },
    { value: 19, label: '19' },
    { value: 20, label: '20' },
    { value: 21, label: '21' },
    { value: 22, label: '22' },
    { value: 23, label: '23' },
    { value: 24, label: '24' },
    { value: 25, label: '25' },
    { value: 26, label: '26' },
    { value: 27, label: '27' },
    { value: 28, label: '28' },
    // { value: 29, label: '29' },
    // { value: 30, label: '30' }
  ]

  const daysOptionsForCollectionReminder = [
    { value: "None", label: 'None' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
  ]

  useEffect(() => {
    let timer;
    if (updateSuccess) {
      timer = setTimeout(() => {
        resetSuccess();
      }, 5000); // 5000ms = 5 seconds
    }
    return () => clearTimeout(timer); // Cleanup on unmount
  }, [updateSuccess, resetSuccess]);

  return (
    <SuperUserSettingsPageUI
      context={context}
      headerText="Prior and Post Days Configuration"
      page="priorDaysConfig"
    >
      <div className="t_content_section">
        <div className="t_content_section_header">
          <PageTitleUI context={context} titleText="Prior and Post Days Configuration" />
        </div>
        <div className="t_content_section_body">
          {loading && <SpinnerComponentUI />}

          {error && (
            <div className="g_error g_m_top_50">
              {error}
            </div>
          )}

          {updateSuccess && (
            <div className="g_success g_m_top_50">
              Configuration updated successfully!
            </div>
          )}

          {!loading && reminderList && reminderList.length === 0 && (
            <div className="g_center g_m_top_100">
              <p className="g_muted">No reminders found.</p>
            </div>
          )}

          {!loading && reminderList && reminderList.length > 0 && (
            <div className="reminder-list">
              <div className="reminder-list-header">
                <div className="reminder-row">
                  <div className="reminder-cell">Reminder Name</div>
                  <div className="reminder-cell">Configuration</div>
                  <div className="reminder-cell">Action</div>
                </div>
              </div>
              <div className="reminder-list-body">
                {reminderList.map((reminder, index) => (
                  <div key={index} className="reminder-row">
                    <div className="reminder-cell">{reminder.name}</div>
                    <div className="reminder-cell">
                      Day of Month: {reminder.dayOfMonth !== null ? reminder.dayOfMonth : 'Not Set'}
                    </div>
                    <div className="reminder-cell">
                      <span
                        className='icon icon-pencil g_link_2'
                        onClick={() => onEditClick(reminder)}
                        style={{ cursor: 'pointer' }}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Edit Modal */}
      {selectedReminder && (
        <div className={`g_modal ${isEditModalOpen ? 'show' : ''}`}>
          <div className="g_modal_overlay" onClick={onModalClose}></div>
          <div className="g_modal_content">
            <div className="g_modal_header">
              <h4>Edit {selectedReminder.name}</h4>
              <span className="icon icon-cross g_modal_close" onClick={onModalClose}></span>
            </div>
            <div className="g_modal_body">
              <div className="g_form_group">
                <label className="g_form_label">Day of Month</label>
                <select
                  className="g_form_control"
                  value={selectedReminder.dayOfMonth || ''}
                  onChange={onDayOfMonthChange}
                >
                  {selectedReminder.isPrior ? daysOptionsForReminder.map((item, index) => (
                    <option className="g_form_option" key={index} value={item.value}>
                      {item.label}
                    </option>
                  )) : daysOptionsForCollectionReminder.map((item, index) => (
                    <option className="g_form_option" key={index} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="g_modal_footer">
              <button className="g_btn g_btn_secondary" onClick={onModalClose}>
                Cancel
              </button>
              <button className="g_btn g_btn_primary" onClick={onUpdateReminder}>
                Update
              </button>
            </div>
          </div>
        </div>
      )}
    </SuperUserSettingsPageUI>
  )
}

export default PriorDaysConfigPageUI